import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {
  mockToken: string = 'fdasfdsa3343214fdasf';
  private readonly TOKEN_NAME : string = 'access_token';

  constructor() {
    localStorage.setItem(this.TOKEN_NAME, this.mockToken);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_NAME);
  }

  setToken(token: string) {
    localStorage.setItem(this.TOKEN_NAME, token);
  }

  clearToken() {
    localStorage.removeItem(this.TOKEN_NAME);
  }

  setUser(user: any) {
    localStorage.setItem('user', user);
  }

}
